export const parseDate = (date: Date): string => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};

export const formatDate = (dateString: string): string => {
    const date = new Date(dateString);
    return parseDate(date);
};

export const isExpired = (expiresAt: string): boolean => {
    const today = new Date();
    const expiryDate = new Date(expiresAt);
    return today > expiryDate;
}; 